/*! hp26 v6j — mobile bottom nav hide rules */
(function(){
  if(!window.matchMedia || !matchMedia('(max-width:767.98px)').matches) return;
  var nav=document.querySelector('.hp26-bnav'); if(!nav) return;
  document.documentElement.classList.add('hp26-bnav-on');
  var lastY=window.scrollY||0, ticking=false, scrollHidden=false;

  function drawerOpen(){
    var cd=document.getElementById('cart-drawer')||document.querySelector('cart-drawer');
    if(!cd) return false;
    if(cd.getAttribute('aria-hidden')==='true') return false;
    if(cd.hasAttribute('open')||cd.classList.contains('is-open')) return true;
    // theme drawer uses aria-hidden=false when open
    if(cd.getAttribute('aria-hidden')==='false') return true;
    return false;
  }
  function overlayOpen(){
    if(document.documentElement.classList.contains('hp26-csm-open')) return true;
    if(drawerOpen()) return true;
    if(document.querySelector('.hp26-sm.is-open')) return true;
    if(document.querySelector('predictive-search[open]')) return true;
    if(document.querySelector('dialog[open], modal-dialog[open], .pswp--open')) return true;
    return false;
  }
  function apply(){
    var hide=overlayOpen() || scrollHidden;
    document.documentElement.classList.toggle('hp26-bnav-hide', hide);
  }
  function onScroll(){
    if(ticking) return; ticking=true;
    requestAnimationFrame(function(){
      var y=window.scrollY||0;
      if(overlayOpen()){ scrollHidden=false; }
      else if(y>lastY+10 && y>100){ scrollHidden=true; }
      else if(y<lastY-10){ scrollHidden=false; }
      if(y<40) scrollHidden=false;
      lastY=y; apply(); ticking=false;
    });
  }
  window.addEventListener('scroll',onScroll,{passive:true});
  document.addEventListener('click',function(){ setTimeout(apply,60); },true);
  new MutationObserver(apply).observe(document.documentElement,{attributes:true,subtree:true,attributeFilter:['open','aria-hidden','class','hidden']});
  setInterval(apply,700);
  apply();

  /* Smile Rewards clearance moved to msm-smile-offset.js (16 Oct 2026) */

})();
